import { typedAction } from "../helpers";
import { currentSharepointFolderState } from "../models/reduxModels";
import { SET_CURRENT_SHAREPOINT_FOLDER_CAN_VIEW } from "./actionTypes";

const initialState: currentSharepointFolderState = { canView: true, canCreateFolder: true };

export const setCanViewFolder = (folderState: currentSharepointFolderState) => {
  return typedAction(SET_CURRENT_SHAREPOINT_FOLDER_CAN_VIEW, folderState);
};

type CurrentSharepointFolderAction = ReturnType<typeof setCanViewFolder>;

export function currentSharepointFolderReducer(
  state = initialState,
  action: CurrentSharepointFolderAction
): currentSharepointFolderState {
  switch (action.type) {
    case SET_CURRENT_SHAREPOINT_FOLDER_CAN_VIEW:
      return { ...action.payload };
    default:
      return state;
  }
}
